import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gr8mfg9fgj: FaireBrandEntity = {
  token: "b_gr8mfg9fgj",
  type: "brand",
  name: "Arbor Cove",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee3fb60b67689d2690655f3ead13c8fd4ada38f7702442db377070f56aa7bcd0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/21d408db4d1eff726f01c9bbe33ddae39fdb5a2bc68326b5345311561fbd2894.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ee3fb60b67689d2690655f3ead13c8fd4ada38f7702442db377070f56aa7bcd0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/21d408db4d1eff726f01c9bbe33ddae39fdb5a2bc68326b5345311561fbd2894.jpeg",
  location: "Idaho Falls, ID, USA",
  minimumOrderDollars: 125,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "This brand was born out of my journey as a mom of three, looking for a way to stay creative and fulfilled while caring for my family. What started as small projects during nap times and late nights has grown into a collection that reflects the things I value most: comfort, beauty, and meaningful connection.\n\nEvery piece I create is inspired by everyday life with little ones, practical enough to be loved and used often yet special enough to feel like a keepsake. My hope is that these products bring a sense of warmth and joy to your customers, the same way they have brought purpose and fulfillment to me.\n\nAt its heart, this brand is about more than just products. It is about sharing a story of family, creativity, and love through thoughtful design.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:59.232Z",
    importedBy: "entity-db-cli",
  },
};
